import { getStepStatus, useStepper } from '.';
import './style.css';
import { HeaderIconProps, HeaderItemProps, LabelItemProps } from './types';

function Item({ children, status }: HeaderItemProps): JSX.Element {
	return (
		<div className={`stepper-item custom-stepper-item pb-5 ${status}`}>
			{children}
		</div>
	);
}

function Label({ title, description, status }: LabelItemProps): JSX.Element {
	return (
		<div className="stepper-label">
			<h3 className={`stepper-title ${status} mb-1`}>{title}</h3>
			{description && <div className="stepper-desc">{description}</div>}
		</div>
	);
}

function Icon({ number, status }: HeaderIconProps): JSX.Element {
	return (
		<div className={`custom-stepper-icon ${status}`}>
			{status === 'completed' ? (
				<i
					className="fas fa-check"
					style={{
						color: '#009ef7',
					}}
				/>
			) : (
				<span className="custom-stepper-number ">{number}</span>
			)}
		</div>
	);
}

export function Header(): JSX.Element {
	const { stepLabels, currentStep } = useStepper();
	return (
		<div className="stepper-nav d-flex justify-content-between flex-wrap mb-10">
			{stepLabels.map((step, index) => {
				const status = getStepStatus(currentStep, index + 1);
				return (
					<Item key={step.label} status={status}>
						<Icon number={index + 1} status={status} />
						<Label
							title={step.label}
							description={step.description}
							status={status}
						/>
					</Item>
				);
			})}
		</div>
	);
}

export { Icon as StepperIcon, Label as StepperLabel, Item as StepperItem };
